import { memo } from 'react'

import SearchableDropdown from 'components/SearchableDropdown'

import TtsLanguageItem from './Item'
import { ITtsLanguageOption } from 'types/text-to-speech'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import { ITtsLanguageDropdownProps } from './types'
import * as Styled from './styled'

const LanguageDropdown: React.FC<ITtsLanguageDropdownProps> = (
  props: ITtsLanguageDropdownProps
) => {
  const {
    languageOptions,
    selectedLanguageId,
    isDataLoading,
    onLanguageChange,
    scrollableParentRef,
    className,
    childClassName
  } = props

  return (
    <Styled.TtsLanguageDropdownWrapper className={className}>
      <SearchableDropdown
        items={languageOptions}
        title={translate(T.LANGUAGE_LABEL)}
        className="language-dropdown"
        ChildComponent={props => (
          <TtsLanguageItem
            {...props}
            item={props.item as ITtsLanguageOption | null}
            className={childClassName}
          />
        )}
        isLoading={isDataLoading || !languageOptions?.length}
        onItemClick={onLanguageChange}
        selectedItemId={selectedLanguageId}
        searchKeys={['id', 'langName']}
        scrollableParentRef={scrollableParentRef}
      />
    </Styled.TtsLanguageDropdownWrapper>
  )
}

export default memo(LanguageDropdown)
